import IcRelationship from '../assets/image/ic_relationship.svg';
import IcRelationshipS from '../assets/image/intelligence/ic_relationship_s.svg';
import IcLanguage from '../assets/image/ic_language.svg';
import IcMath from '../assets/image/ic_math.svg';
import IcPhysics from '../assets/image/ic_physics.svg';
import IcReflection from '../assets/image/ic_reflection.svg';
import IcNature from '../assets/image/ic_nature.svg';
import IcSpace from '../assets/image/ic_space.svg';
import IcMusic from '../assets/image/ic_music.svg';

export const ON_KIDS_TOKEN = 'onkids-token';
export const ON_KIDS_REFRESH_TOKEN = 'onkids-refresh_token';
export const ON_KIDS_DID_SPLASH_VIEW = 'onkids-did-splash-view';
export const ACCESS_TOKEN_KEY = 'onkids-token-access';
export const REFRESH_TOKEN_KEY = 'onkids-token-refresh';
export const WELCOME_SKIPPED_KEY = 'isWelcomeSkipped';
export const ON_KIDS_VISITED = 'onkids-visited';
export const ON_KIDS_DRAFT_NAME = 'onkids-draft-name';
export const ON_KIDS_DRAFT_BIRTH = 'onkids-draft-birth';
export const ON_KIDS_DRAFT_GENDER = 'onkids-draft-gender';
export const ON_KIDS_ANALYSIS_THUMBNAIL = 'onkids_analysis_thumbnail';
export const ON_KIDS_ANALYSIS_TYPE = 'onkids_analysis_type';
export const ON_KIDS_MAIN_KID_ID = 'onkids-main-kid-id';

// 서버 AI 워커가 단계별로 기록하는 진행률(report-ai.processor). 화면 타이머는 다음 단계값 직전에서 멈춘다.
export const AI_JOB_PROGRESS_STEPS = [10, 20, 45, 55, 65, 75, 85, 90, 98] as const;

export const VIEW = {
  SPLASH: 'splash',
  LOGIN: 'login',
  PERMITTED: 'permitted',
} as const;

export const SIGNUP_TYPE = {
  KAKAO: 'kakao',
  PASS: 'pass',
} as const;

export const GENDER = {
  UNKNOWN: 'unknown',
  MALE: 'male',
  FEMALE: 'female',
} as const;

export const BOTTOM_NAVI = {
  HOME: 1,
  HISTORY: 2,
  EDUCATION: 3,
  COMMUNITY: 4,
  MY: 5,
} as const;

export const BOTTOM_NAVI_V2 = {
  HOME: 1,
  REPORT: 2,
  EDUCATION: 3,
  MY: 4,
  COMMUNITY: 5,
} as const;

export const AGREEMENT = {
  AGE: 'agePolicy',
  SERVICE: 'termsOfService',
  PRIVACY: 'privacyPolicy',
  EVENT: 'eventAlarm',
} as const;

export const VIDEO_RECORD_TYPE = {
  DAILY: 1,
  QNA: 2,
} as const;

export const REPORT_STATUS = {
  BEFORE: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2,
  CANCELED: 3,
  DRAFT: 4,
} as const;

export const ANALYSIS_STATUS = {
  STANDBY: 'standby',
  PENDING: 'pending',
  SUCCESS: 'success',
  NOTHING: 'nothing',
  ERROR: 'error',
} as const;

export const AI_JOB_STATUS = {
  QUEUED: 'queued',
  RUNNING: 'running',
  RETRYING: 'retrying',
  SUCCESS: 'success',
  FAILED: 'failed',
  CANCELED: 'canceled',
} as const;

export const TALENT_ID = {
  LANGUAGE: 1,
  MUSIC: 2,
  PHYSICAL: 3,
  MATH: 4,
  SPACE: 5,
  RELATIONSHIP: 6,
  REFLECTION: 7,
  NATURE: 8,
} as const;

export interface RecordQuestion {
  id: number;
  text: string[];
  label: string;
}

export const RECORD_QUESTIONS: RecordQuestion[] = [
  {
    id: TALENT_ID.LANGUAGE,
    text: [
      `네가 좋아하는 동화\n하나 말해줄래?\n무슨 내용이야?`,
      `아이스크림, 놀이공원, 자전거로\n짧은 이야기를 만들어볼래?`,
      `흥부와 놀부 이야기에서,\n놀부는 왜 제비 다리를\n부러뜨렸을까?`,
    ],
    label: '언어',
  },
  {
    id: TALENT_ID.MUSIC,
    text: [
      `가장 좋아하는 노래를 불러줘.`,
      `노래를 만든다면\n어떤 악기를 쓰고 싶어?\n여러 개도 괜찮아.`,
      `작은 별을 빠르게 불렀다가\n느리게도 불러볼래?`,
      `좋아하는 노래를\n엄마/아빠가 배울 수 있게\n알려줘.`,
    ],
    label: '음악',
  },
  {
    id: TALENT_ID.PHYSICAL,
    text: [
      `어떤 운동을 좋아해?\n좋아하는 운동 동작\n한 가지를 해볼래?`,
      `친구나 선생님 표정을\n흉내 내볼 수 있어?\n몸짓도 같이 해볼래?`,
      `(순서를 섞어서 여러 번 제시)\n1. 앞으로 한 발\n2. 옆으로 한 발 3. 위로 점프`,
      `자유롭게 춤을 춰 보자.`,
    ],
    label: '신체운동',
  },
  {
    id: TALENT_ID.MATH,
    text: [
      `규칙을 지키며\n놀이해 본 적 있어?\n그 규칙은 뭐였어?`,
      `저녁 식사를 차릴 때\n어떤 순서로 준비해?`,
      `요구르트 병 3개,\n콜라 캔 2개, 상자 1개로\n뭘 만들 수 있을까?`,
    ],
    label: '논리수학',
  },
  {
    id: TALENT_ID.SPACE,
    text: [
      `유치원(또는 자주 가는 곳)\n가는 길에 뭐가 보여?`,
      `레고가 있으면 뭘 만들고 싶어?\n어떻게 만들까?`,
      `이 방에서 숨바꼭질을 할 때\n어디에 숨으면 잘 안 보일까?`,
      `엄마 얼굴이\n어떻게 생겼는지 말해줘.`,
    ],
    label: '공간',
  },
  {
    id: TALENT_ID.RELATIONSHIP,
    text: [
      `OO이가 놀부라면\n동생에게 어떻게\n대해주고 싶어?`,
      `놀이터에서 친구 두 명이\n다투고 있으면\n어떻게 할거야?`,
      `게임이나 대결을 할 때,\n이기기 위해 같은 팀을\n도와준 적 있어?`,
      `친구에게 부탁이 있다면\n어떻게 이야기할까?`,
    ],
    label: '대인관계',
  },
  {
    id: TALENT_ID.REFLECTION,
    text: [
      `행복한 왕자 이야기에서\n왕자의 입장이라면\n어떤 기분이 들 것 같아?`,
      `착한 일을 한 적이 있어?\n그 때 기분이 어땠어?`,
      `하고 싶은 일을 하기 위해\n스스로 어떤 노력을\n했는지 말해줄래?`,
    ],
    label: '자기성찰',
  },
  {
    id: TALENT_ID.NATURE,
    text: [
      `좋아하는 동물한테\n1. 어떻게 먹이를 줄거야?\n2. 어떻게 놀아 줄거야?`,
      `나뭇잎, 돌멩이, 나뭇가지가 있다면,\n이것들로 무얼 만들 수 있어?`,
      `화분에 물을 주는 방법을 보여줘.`,
      `식물이 자라면 어떤 모습일까?`,
    ],
    label: '자연친화',
  },
];

export interface TalentChip {
  id: number;
  labels: string[];
}

export const TALENT_CHIPS: TalentChip[] = [
  {
    id: TALENT_ID.LANGUAGE,
    labels: ['언어이해', '언어표현', '소통'],
  },
  { id: TALENT_ID.MUSIC, labels: ['음감', '리듬감각', '악기'] },
  {
    id: TALENT_ID.PHYSICAL,
    labels: ['신체표현', '운동감각', '비언어표현'],
  },
  {
    id: TALENT_ID.MATH,
    labels: ['수학적사고', '논리적추론', '문제해결'],
  },
  {
    id: TALENT_ID.SPACE,
    labels: ['공간감각', '공간구성', '길찾기'],
  },
  { id: TALENT_ID.RELATIONSHIP, labels: ['사회성', '타인이해', '또래관계'] },
  { id: TALENT_ID.REFLECTION, labels: ['자기이해', '감정인식', '자기조절'] },
  {
    id: TALENT_ID.NATURE,
    labels: ['동식물', '자연환경', '탐구'],
  },
];

export interface TalentInfo {
  id: number;
  key: string;
  label: string;
  icon: string;
  description: string;
  iconS?: string;
  recordGuide?: string;
}

export const TALENT: Record<string, TalentInfo> = {
  LANGUAGE: {
    id: TALENT_ID.LANGUAGE,
    key: 'language',
    label: '언어',
    icon: IcLanguage,
    description: '생각을 말과 글로 표현하는 능력이예요.',
  },
  MUSIC: {
    id: TALENT_ID.MUSIC,
    key: 'music',
    label: '음악',
    icon: IcMusic,
    description: '음악적 요소를 이해하고 표현하는 능력이예요.',
  },
  PHYSICAL: {
    id: TALENT_ID.PHYSICAL,
    key: 'physical',
    label: '신체운동',
    icon: IcPhysics,
    description: '신체를 정교하게 움직여 표현하는 능력이예요.',
  },
  MATH: {
    id: TALENT_ID.MATH,
    key: 'math',
    label: '논리수학',
    icon: IcMath,
    description: '논리적으로 사고하고 추론하는 능력이예요.',
  },
  SPACE: {
    id: TALENT_ID.SPACE,
    key: 'space',
    label: '공간',
    icon: IcSpace,
    description: '장면을 머릿속에 잘 떠올려 표현했어요.',
  },
  RELATIONSHIP: {
    id: TALENT_ID.RELATIONSHIP,
    key: 'relationship',
    label: '대인관계',
    icon: IcRelationship,
    description: '타인을 이해하고 상호작용하는 능력이예요.',
  },
  REFLECTION: {
    id: TALENT_ID.REFLECTION,
    key: 'reflection',
    label: '자기성찰',
    icon: IcReflection,
    description: '자신의 감정과 생각을 이해하는 능력이예요.',
  },
  NATURE: {
    id: TALENT_ID.NATURE,
    key: 'nature',
    label: '자연친화',
    icon: IcNature,
    description: '자연에 관심을 갖고 탐구하는 능력이예요.',
  },
};

export const TALENT_ARR: TalentInfo[] = [
  {
    id: TALENT_ID.LANGUAGE,
    key: 'language',
    label: '언어',
    icon: IcLanguage,
    iconS: IcRelationshipS,
    description: '생각을 말과 글로 표현하는 능력이예요.',
    recordGuide:
      '읽은 책에 대해 이야기하거나 함께 대화하는 모습, 단어 놀이를 하는 장면을 촬영합니다.',
  },
  {
    id: TALENT_ID.MUSIC,
    key: 'music',
    label: '음악',
    icon: IcMusic,
    iconS: IcRelationshipS,
    description: '음악적 요소를 이해하고 표현하는 능력이예요.',
    recordGuide: '노래하기, 악기 연주하기, 리듬 맞추기 등 음악적 표현을 담는 것이 좋습니다.',
  },
  {
    id: TALENT_ID.PHYSICAL,
    key: 'physical',
    label: '신체운동',
    icon: IcPhysics,
    iconS: IcRelationshipS,
    description: '신체를 정교하게 움직여 표현하는 능력이예요.',
    recordGuide: '춤추기, 운동하기, 손동작하기 등 신체 활동을 기록합니다.',
  },
  {
    id: TALENT_ID.MATH,
    key: 'math',
    label: '논리수학',
    icon: IcMath,
    iconS: IcRelationshipS,
    description: '논리적으로 사고하고 추론하는 능력이예요.',
    recordGuide: '숫자를 세거나 퍼즐을 맞추고, 패턴을 찾는 활동을 담습니다.',
  },
  {
    id: TALENT_ID.SPACE,
    key: 'space',
    label: '공간',
    icon: IcSpace,
    iconS: IcRelationshipS,
    description: '장면을 머릿속에 잘 떠올려 표현했어요.',
    recordGuide: '블록 쌓기, 그림 그리기, 길 찾기 등 공간 지각력을 활용한 활동을 촬영합니다.',
  },
  {
    id: TALENT_ID.RELATIONSHIP,
    key: 'relationship',
    label: '대인관계',
    icon: IcRelationship,
    iconS: IcRelationshipS,
    description: '타인을 이해하고 상호작용하는 능력이예요.',
    recordGuide:
      '친구와 함께 놀기, 가족과 대화하기, 협력 게임하기 등 다른 사람과 상호작용하는 모습을 촬영합니다.',
  },
  {
    id: TALENT_ID.REFLECTION,
    key: 'reflection',
    label: '자기성찰',
    icon: IcReflection,
    iconS: IcRelationshipS,
    description: '자신의 감정과 생각을 이해하는 능력이예요.',
    recordGuide:
      '일기를 쓰고 읽는 장면, 자신의 생각을 말하는 모습, 느낀 감정을 표현하는 활동을 기록합니다.',
  },
  {
    id: TALENT_ID.NATURE,
    key: 'nature',
    label: '자연친화',
    icon: IcNature,
    iconS: IcRelationshipS,
    description: '자연에 관심을 갖고 탐구하는 능력이예요.',
    recordGuide: '식물을 관찰하거나 동물을 보고, 날씨를 살피는 등 자연과 교감하는 활동을 담습니다.',
  },
];

export interface TalentCategoryInfo {
  id: number;
  label: string;
  category: { category: number; label: string }[];
}

export const TALENT_CATEGORIES: TalentCategoryInfo[] = [
  {
    id: TALENT_ID.LANGUAGE,
    label: '언어',
    category: [
      { category: 1, label: '어휘력' },
      { category: 2, label: '논리적 말하기' },
      { category: 3, label: '언어 유창성' },
      { category: 4, label: '이해력 및 설명력' },
      { category: 5, label: '감정표현' },
    ],
  },
  {
    id: TALENT_ID.MUSIC,
    label: '음악',
    category: [
      { category: 1, label: '음악지각' },
      { category: 2, label: '음악이해' },
      { category: 3, label: '음악창작' },
      { category: 4, label: '음악재현' },
      { category: 5, label: '음악수행' },
    ],
  },
  {
    id: TALENT_ID.PHYSICAL,
    label: '신체운동',
    category: [
      { category: 1, label: '신체 조절력' },
      { category: 2, label: '신체 표현력' },
      { category: 3, label: '순발력과 반응성' },
      { category: 4, label: '신체 문제 해결력' },
    ],
  },
  {
    id: TALENT_ID.MATH,
    label: '논리수학',
    category: [
      { category: 1, label: '수와 연산' },
      { category: 2, label: '문제해결력' },
      { category: 3, label: '규칙 발견' },
      { category: 4, label: '개념 활용' },
      { category: 5, label: '논리 추론' },
    ],
  },
  {
    id: TALENT_ID.SPACE,
    label: '공간',
    category: [
      { category: 1, label: '공간 인식' },
      { category: 2, label: '입체 구성 능력' },
      { category: 3, label: '방향 위치 활용' },
      { category: 4, label: '공간 활용' },
      { category: 5, label: '창의적 시각 표현' },
    ],
  },
  {
    id: TALENT_ID.RELATIONSHIP,
    label: '대인관계',
    category: [
      { category: 1, label: '공감 능력' },
      { category: 2, label: '협력' },
      { category: 3, label: '갈등 조절' },
      { category: 4, label: '설득 및 이해' },
    ],
  },
  {
    id: TALENT_ID.REFLECTION,
    label: '자기성찰',
    category: [
      { category: 1, label: '감정 인식 및 표현' },
      { category: 2, label: '자기주도성' },
      { category: 3, label: '자기이해' },
      { category: 4, label: '자기성찰' },
    ],
  },
  {
    id: TALENT_ID.NATURE,
    label: '자연친화',
    category: [
      { category: 1, label: '동식물 이해 및 돌봄' },
      { category: 2, label: '자연 탐구 태도' },
      { category: 3, label: '환경 감수성' },
      { category: 4, label: '자연 표현' },
    ],
  },
];

export const SELECT_STYLE = {
  minWidth: '140px',
  height: '43px',
  borderRadius: '25px',
  backgroundColor: '#FFF',
  fontSize: '14px',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#fff',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#fff',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#fff',
  },
  '.MuiSelect-select': {
    padding: '8px 16px',
  },
};

export const COMMUNITY_TABS = [
  { label: '공지사항', value: 0 },
  { label: '이벤트', value: 1 },
  { label: 'Q&A', value: 2 },
  { label: '자유게시판', value: 3 },
] as const;

export const MY_LIST_TABS = [
  { label: '1:1문의', value: 0 },
  { label: 'Q&A', value: 1 },
  { label: '자유게시판', value: 2 },
] as const;

export const COMMUNITY_TYPE = {
  ANALYSIS: 1,
  GROWTH: 2,
  FREE_BOARD: 3,
} as const;

export const COMMUNITY_QNA_TYPE = {
  ALL: 'all',
  ANALYSIS: 'report',
  GROWTH: 'growth',
  ACCUMULATED: 'accumulated',
} as const;

export const COMMUNITY_USER_TYPE = {
  ALL: 'all',
  USER: 'user',
  EXPERT: 'expert',
} as const;

export const COMMUNITY_WRITE_TYPES = [
  { id: COMMUNITY_TYPE.ANALYSIS, label: 'Q&A - 분석리포트', title: '분석리포트' },
  { id: COMMUNITY_TYPE.GROWTH, label: 'Q&A - 성장변화', title: '성장변화' },
  { id: COMMUNITY_TYPE.FREE_BOARD, label: '자유게시판', title: '자유게시판' },
] as const;

export const COMPLAINT_TARGET_TYPE = {
  EVENT: 'EVENT',
  EVENT_ANSWER: 'EVENT_ANSWER',
  QUESTION: 'QUESTION',
  QUESTION_ANSWER: 'QUESTION_ANSWER',
  FREEBOARD_POST: 'FREEBOARD_POST',
  FREEBOARD_COMMENT: 'FREEBOARD_COMMENT',
} as const;

export interface DummyIntelligenceCategory {
  category: number;
  observation: boolean;
  summary: string;
}

export interface DummyIntelligenceData {
  intelligence: number;
  categories: DummyIntelligenceCategory[];
  final_summary: string | null;
  score: number | null;
  percentile: number | null;
}

export const dummyData: DummyIntelligenceData[] = [
  {
    intelligence: 1,
    categories: [
      {
        category: 1,
        observation: true,
        summary:
          "전문적인 개념을 '로로', '로루'와 같은 자체적이고 친숙한 표현으로 바꾸어 사용하며, '짠!'과 같은 감탄사를 통해 감정을 표현하는 어휘를 사용함.",
      },
      {
        category: 2,
        observation: true,
        summary:
          "접속사('그러면', '~니까', '왜냐하면')를 사용하여 조작 순서와 이유, 원인과 결과를 논리적인 흐름으로 설명하며, 현재 상태와 다음 목표를 연결 짓거나 다음 단계를 명확히 알리고 이유와 주의사항을 함께 제시하는 등 논리적이고 설득력 있는 말하기를 구사함.",
      },
      {
        category: 3,
        observation: true,
        summary:
          '방해받는 상황이나 자신의 풀이 과정을 평가하고 수정하는 과정에서도 중단 없이 복잡한 조작 단계를 유창하게 설명하며, 즉흥적인 말하기 능력을 보여줌.',
      },
      {
        category: 4,
        observation: true,
        summary:
          "루빅스 큐브의 복잡한 개념, 규칙, 조작 방식을 '하얀색이 네 군데가 있어서', '색깔이 똑같아야 해요', '앞으로 돌리고' 등 구체적이고 시각적이며 간결하고 직접적인 표현을 사용하여 쉽게 전달하며, 정확한 정보 전달을 위해 노력함.",
      },
      {
        category: 5,
        observation: true,
        summary:
          "큐브 완성 후 '짠! 다 맞춰졌네요'와 같은 말과 함께 밝게 웃는 모습에서 성취감과 기쁨 등 감정을 풍부하게 표현함.",
      },
    ],
    final_summary:
      '언어지능 분석 결과, 논리적 말하기, 이해력 및 설명력, 언어 유창성 영역에서 뛰어난 모습을 보여주었으며, 어휘력과 감정표현 능력 또한 관찰되었습니다. 전반적으로 복잡한 과정을 명확하고 유창하게 전달하며, 논리적이고 설득력 있는 의사소통 능력이 뛰어난 경향을 보입니다.',
    score: 76,
    percentile: 76,
  },
  {
    intelligence: 3,
    categories: [
      {
        category: 1,
        observation: true,
        summary:
          "'신체 조절력'과 관련하여 큐브 조작 시 손가락과 손목을 섬세하고 정확하게 움직이며, 빠르고 유연하게 큐브 면을 회전시키고 복잡한 알고리즘을 부드럽게 연결하는 등 뛰어난 신체 조절 능력을 보여주었습니다.",
      },
      { category: 2, observation: false, summary: '관찰 불가' },
      { category: 3, observation: false, summary: '관찰 불가' },
      {
        category: 4,
        observation: true,
        summary:
          "'신체 문제 해결력'과 관련하여 큐브의 조각들을 원하는 위치로 이동시키기 위해 정해진 복잡한 회전 알고리즘을 신체 움직임으로 정확히 구현하고, 큐브의 현재 상태와 목표에 맞춰 동작을 조정하며 문제를 해결해 나가는 뛰어난 모습을 보입니다.",
      },
    ],
    final_summary:
      "신체운동지능 분석 결과, 섬세한 손가락과 손목 움직임을 통한 '신체 조절력'과 큐브 퍼즐 해결을 위한 '신체 문제 해결력'에 뛰어난 모습을 보여주었습니다. 특히, 빠르고 정확하며 유연한 동작으로 복잡한 알고리즘을 구현하고, 미세한 조절을 통해 문제 해결 과정을 완수하는 경향을 보입니다. '신체 표현력'과 '순발력과 반응성'은 직접적으로 관찰되지 않았지만, 전반적으로 신체를 도구로 활용하여 복잡한 과제를 정밀하고 효율적으로 수행하는 능력이 매우 뛰어납니다.",
    score: 87,
    percentile: 87,
  },
  {
    intelligence: 4,
    categories: [
      { category: 1, observation: false, summary: '관찰 불가' },
      {
        category: 2,
        observation: true,
        summary:
          '복잡한 루빅스 큐브 문제를 작은 단계로 분해하여 목표를 설정하고, 체계적인 알고리즘 적용 및 오류 수정 재시도를 통해 성공적으로 해결하는 뛰어난 문제해결 능력을 보였습니다.',
      },
      {
        category: 3,
        observation: true,
        summary:
          '루빅스 큐브 조각의 위치와 상태, 색깔 규칙 등 구성 원리를 정확하게 인식하고 이해하며, 복잡한 배열 속에서 필요한 정보를 빠르게 파악하여 패턴과 관계를 인지하는 능력이 뛰어났습니다.',
      },
      {
        category: 4,
        observation: true,
        summary:
          '회전 각도와 같은 기초적인 수학적 개념을 루빅스 큐브 조작에 적용하여 설명하는 모습을 통해, 수학적 개념을 실생활 문제 해결에 활용하는 능력을 보여주었습니다.',
      },
      {
        category: 5,
        observation: true,
        summary:
          '현재 상황에 대한 논리적 근거를 제시하고, 자신의 시도 결과를 비판적으로 평가하며 문제점을 즉각적으로 인식하는 비판적 사고 능력이 뛰어났습니다. 또한, 사물의 상태를 정확하게 분류하고 복잡한 시스템의 작동 원리를 이해하여 결과를 예측하는 뛰어난 논리적 추론 능력을 보였습니다.',
      },
    ],
    final_summary:
      "논리수학지능 분석 결과, 루빅스 큐브 문제 해결 과정에서 뛰어난 문제해결력, 규칙 발견 능력, 수학적 개념 활용 능력, 그리고 비판적 사고를 동반한 논리적 추론 능력을 고루 보여주었습니다. 특히, 복잡한 문제를 체계적으로 분석하고 해결하며, 결과에 따라 유연하게 전략을 수정하는 모습이 인상 깊었습니다. 빠른 암산과 계산 능력과 관련된 '수와 연산' 영역은 관찰이 어려웠지만, 전반적으로 추상적인 사고와 구체적인 문제 해결을 연계하는 뛰어난 논리수학지능을 지닌 것으로 판단됩니다.",
    score: 79,
    percentile: 79,
  },
  {
    intelligence: 5,
    categories: [
      {
        category: 1,
        observation: true,
        summary:
          '시각적-공간적 정보를 인식하고 조작하는 능력과 관련하여, 루빅스 큐브의 특정 형태(데이지, 십자가)와 색깔 패턴을 정확히 인식하고 이를 바탕으로 큐브를 조작하여 원하는 형태를 만드는 뛰어난 능력을 보여주었습니다. 특히, 복잡한 공간 퍼즐의 시각적 목표를 설정하고 최종 형태를 성공적으로 인식하는 모습이 두드러집니다.',
      },
      {
        category: 2,
        observation: true,
        summary:
          '입체 구조를 만들고 조작하는 능력과 관련하여, 큐브 조각의 위치를 파악하고 정확한 손놀림과 복합적인 회전 동작을 통해 입체 구조를 능숙하게 조작하고 변형하는 뛰어난 능력을 보여주었습니다.',
      },
      {
        category: 3,
        observation: true,
        summary:
          "방향과 위치를 인지하고 활용하는 능력과 관련하여, 큐브 조각의 '아래', '가운데'와 같은 위치 개념 및 '돌려야' 하는 조작 방향, '오른쪽', '왼쪽'과 같은 특정 방향을 정확히 인지하고 활용하는 능력이 뛰어남을 알 수 있습니다.",
      },
      {
        category: 4,
        observation: true,
        summary:
          '공간을 전략적으로 활용하는 능력과 관련하여, 루빅스 큐브를 해결하기 위해 특정 알고리즘을 체계적으로 적용하고, 현재 공간 상태를 파악하여 목표 달성을 위한 필요한 조작을 반복 수행하는 등 공간을 매우 효율적이고 전략적으로 활용하는 모습을 보여주었습니다.',
      },
      { category: 5, observation: false, summary: '관찰 불가' },
    ],
    final_summary:
      '공간지능 분석 결과, 루빅스 큐브의 복잡한 시각적 목표와 패턴을 정확히 인식하고, 입체 구조를 능숙하게 구성하며, 방향과 위치를 활용하여 공간을 조작하는 데 뛰어난 모습을 보여주었습니다. 특히, 문제 해결을 위해 공간을 전략적으로 활용하는 능력이 두드러졌습니다. 창의적 시각 표현과 관련된 모습은 관찰이 어려웠지만, 전반적으로 시각적-공간적 정보를 이해하고 조작하는 데 매우 능숙한 경향을 보입니다.',
    score: 87,
    percentile: 87,
  },
  {
    intelligence: 2,
    categories: [
      { category: 1, observation: false, summary: '관찰 불가' },
      { category: 2, observation: false, summary: '관찰 불가' },
      { category: 3, observation: false, summary: '관찰 불가' },
      {
        category: 4,
        observation: true,
        summary:
          "'음악재현'과 관련하여 악보 없이 바이올린으로 일련의 음을 연주하며 멜로디를 구성하려는 시도를 보이며, 들은 멜로디를 기억하거나 스스로 멜로디를 만들어 연주하는 능력이 관찰됨",
      },
      {
        category: 5,
        observation: true,
        summary:
          "'음악수행'과 관련하여 바이올린과 활을 사용하여 자발적으로 소리를 내며 음악적 표현을 시도하고, 악기 연주 시 올바른 주법을 유지하려는 노력이 관찰됨",
      },
    ],

    final_summary:
      '음악지능 분석 결과, 음악재현 능력과 음악수행 능력에 뛰어난 모습을 보여주었고, 음악지각, 음악이해, 음악창작과 같은 다른 영역의 모습은 관찰이 어려웠지만, 전반적으로 악기를 활용하여 자율적으로 음악을 표현하고 재현하려는 경향을 보입니다.',
    score: 62,
    percentile: 62,
  },
  {
    intelligence: 8,
    categories: [
      {
        category: 1,
        observation: true,
        summary:
          '동식물(고양이)의 움직임과 상호작용에 깊은 관심을 보이며, 면밀히 관찰하고 흥미를 드러내는 모습을 보여줌',
      },
      {
        category: 2,
        observation: true,
        summary:
          '자연(동물)에 대한 긍정적인 관심과 호기심을 바탕으로, 고양이의 행동을 유심히 관찰하고 상호작용에 집중하는 탐구적인 태도를 보임',
      },
      { category: 3, observation: false, summary: '관찰 불가' },
      { category: 4, observation: false, summary: '관찰 불가' },
    ],
    final_summary:
      '자연친화지능 분석 결과, 동식물에 대한 깊은 관심과 탐구 태도에 뛰어난 모습을 보여주었고, 환경 감수성 및 자연 표현과 관련된 모습은 관찰이 어려웠지만, 전반적으로 자연 현상에 대한 높은 관심과 호기심을 통해 탐구하려는 경향을 보입니다.',
    score: 75,
    percentile: 75,
  },
  {
    intelligence: 6,
    categories: [
      {
        category: 1,
        observation: true,
        summary:
          '공감 능력과 관련하여 타인의 어려움을 예측하고 고려하며, 타인에 대한 긍정적인 감정을 직접적으로 표현하고 지지하는 모습을 보여줍니다.',
      },
      {
        category: 2,
        observation: true,
        summary:
          '협력과 관련하여 공동의 과제에 적극적으로 참여하며 구체적인 아이디어를 제시하고, 다른 사람들을 함께 활동에 참여시키려는 주도적인 태도를 보이며 공동의 즐거움을 추구합니다. 또한, 즉시 대안을 제시하여 모두가 함께 할 수 있는 방법을 모색합니다.',
      },
      {
        category: 3,
        observation: true,
        summary:
          '갈등 조절과 관련하여 상대방과의 의견을 조율하고 타협점을 찾아 갈등을 해결하려는 모습을 보여주며, 명확한 절충안을 제시합니다.',
      },
      {
        category: 4,
        observation: true,
        summary:
          '설득 및 이해와 관련하여 자신의 입장을 명확히 전달하고 상대방의 의견을 고려하며 동의를 유도하는 의사소통 능력을 보입니다. 또한, 언어적, 비언어적 방법을 모두 활용하여 상대를 설득하고 구체적인 해결책을 제시하여 이해를 구하는 모습을 보여줍니다.',
      },
    ],
    final_summary:
      '대인관계지능 분석 결과, 타인의 감정을 이해하고 지지하는 공감 능력, 공동의 목표를 위해 적극적으로 참여하고 타인을 포용하려는 협력적인 태도, 갈등 상황에서 합리적인 타협점을 모색하는 갈등 조절 능력, 그리고 자신의 의견을 명확하고 설득력 있게 전달하는 의사소통 능력이 모두 뛰어난 모습을 보였습니다. 전반적으로 다양한 상황에서 타인과 긍정적이고 효과적으로 상호작용하려는 경향을 보입니다.',
    score: 72,
    percentile: 72,
  },
  {
    intelligence: 7,
    categories: [
      {
        category: 1,
        observation: true,
        summary:
          '자신의 불편함, 만족감, 과거의 감정 등을 표정이나 언어로 솔직하고 명확하게 표현하는 모습을 보였습니다.',
      },
      {
        category: 2,
        observation: true,
        summary:
          '다양한 목표를 스스로 설정하고, 이를 달성하기 위한 구체적인 계획과 우선순위를 제시하는 등 뛰어난 자기주도적 성향을 보였습니다.',
      },
      {
        category: 3,
        observation: true,
        summary:
          '자신의 인지나 한계, 공간적 특성 및 예상되는 어려움을 명확히 인식하고 표현하며, 불확실한 상황을 스스로 확인하려는 모습을 보였습니다. 또한 자신의 상상력을 활용하여 상황을 이해하고 설명하는 유연한 사고를 보였으며, 관계에 대한 자신만의 이해와 기대를 드러내기도 했습니다.',
      },
      { category: 4, observation: false, summary: '관찰 불가' },
    ],
    final_summary:
      '자기성찰지능 분석 결과, 자신의 감정을 솔직하고 명확하게 표현하고 인식하는 데 뛰어난 모습을 보였습니다. 또한 목표를 설정하고 구체적인 계획을 수립하는 자기주도적 성향이 강하며, 자신의 인지나 한계, 외부 환경과의 상호작용에 대한 이해도가 높게 관찰되었습니다. 그러나 (그림) 일기나 글쓰기와 같은 직접적인 자기성찰 활동은 관찰되지 않았지만, 전반적으로 자신을 이해하고 삶을 주도하려는 경향을 보입니다.',
    score: 70,
    percentile: 70,
  },
];
